import { isPlatformNodeJS } from '@utils/common';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { authenticateComponentFrameworkRequest } from './util.authenticate-component-framework-request.js';

const getComponentDataQuery = (componentId, meta) => {
  return {
    queryKey: ["component-framework/get-data", componentId],
    queryFn: async () => {
      return await fetchComponentData(componentId, meta.schema, meta.processors);
    },
    // fetching will always be handled explicitly using client.prefetchQuery()
    enabled: false,
    staleTime: isPlatformNodeJS() ? 0 : 1.5 * HOURS_TO_MS,
    gcTime: isPlatformNodeJS() ? 0 : 1 * DAYS_TO_MS,
    meta: {
      persist: false
    }
  };
};
async function fetchComponentData(componentId, schema, processors) {
  const url = `${process.env["COMPONENT_FRAMEWORK_API"]}/api/Components/Get/${encodeURIComponent(componentId)}`;
  try {
    const res = await fetch(...authenticateComponentFrameworkRequest(url));
    if (res.status === 404) {
      return {
        state: "not-found"
      };
    }
    if (res.status < 200 || res.status >= 300) {
      throw new Error(await res.text());
    }
    const envelope = await res.json();
    if (!envelope.Content) {
      return {
        state: "empty",
        envelope
      };
    }
    const data = JSON.parse(envelope.Content);
    delete envelope.Content;
    try {
      const preparedData = (await processors?.preValidation?.(data)) ?? data;
      const validatedData = schema.parse(preparedData);
      return {
        state: "valid",
        envelope,
        data: (await processors?.postValidation?.(validatedData)) ?? validatedData
      };
    } catch (err) {
      console.log("fetchComponentData(): parsing data failed", err);
      return {
        state: "invalid",
        data,
        envelope,
        error: err
      };
    }
  } catch (err) {
    console.log("fetchComponentData(): failed for", url, {
      componentId
    });
    throw err;
  }
}

export { getComponentDataQuery };
//# sourceMappingURL=request.fetch-component-data.js.map
